import { http, HttpResponse } from 'msw'
import { StatusCodes } from 'http-status-codes'

import { allSuppliers } from 'app/mocks/data/catalogue/suppliers'

import { api } from 'app/utils/constants'

import { SupplierPayload } from 'app/types/catalogue/supplier'

export const updateSupplier = http.patch(
    `${process.env.REACT_APP_API_ADDRESS}/${api.catalogue.suppliers.DETAILS}`,
    async ({ request, params }) => {
        const { id } = params
        const payload = await request.json()

        const payloadParsed = SupplierPayload.safeParse(payload)

        const supplierFound = allSuppliers.find(
            (supplier) => supplier.id.toString() === id,
        )

        // Wrong data
        if (!payloadParsed.success) {
            return HttpResponse.json(undefined, {
                status: StatusCodes.UNPROCESSABLE_ENTITY,
            })
        }

        // Not found
        if (!supplierFound) {
            return HttpResponse.json(undefined, {
                status: StatusCodes.NOT_FOUND,
            })
        }

        return HttpResponse.json<SupplierPayload>({
            ...supplierFound,
            ...payloadParsed.data,
            client: payloadParsed.data.client ?? supplierFound.client.id,
        })
    },
)
